import { UserPermissions } from '@/utils/userInfo';

export const GetUserInfoFromLocalStorage = {
    data() {
        return {
            UserInfo: UserPermissions.getUserInfoFromLocalStorage()
        }
    },
};


// WEBPACK FOOTER //
// ./src/mixins/GetUserInfoFromLocalStorage.js